import React, { useState, useEffect, useRef } from 'react';

// import PropTypes from 'prop-types';

import { Icon } from 'modules/icon-bank';
import classnames from 'classnames';
import { noop } from 'lodash';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { sliderCarausel as SliderCarausel } from 'ui/views/sliderCarausel';
 *
 * // render
 * <SliderCarausel propName='propValue'/>
 */
export const sliderCarausel = ( props ) => {

    const { listSize = 0, overflowCount = 1, onSlide = noop, autoPickChild = true } = props;

    /*
        Auto pick child picks the very first child & use it for calculations.
        If you want specific child mark it false & use listItemRef to get specific childs reference.
    */

    const classNames = classnames( 'ui-slider-carausel', props.classNames );

    const [ counterIndex, setCounterIndex ] = useState( 0 );

    // **IMPORTANT**: Please attach these refs on suitable elments for this component to work.
    const listRef = useRef( null ); // parent ref

    const listItemRef = useRef( null ); // child ref

    const rightArrowCallback = () => {

        if ( listSize - counterIndex > overflowCount ) {

            setCounterIndex( counterIndex + 1 );
        }
    };

    const leftArrowCallback = () => {

        if ( 0 < counterIndex ) {

            setCounterIndex( counterIndex - 1 );
        }
    };

    const getMargin = () => {
        if ( 0 === counterIndex ) {
            return 0;
            
        } else if ( 0 < counterIndex ) {
            if( autoPickChild ) {
                const element = listRef.current.firstElementChild;
                return -element.offsetWidth * counterIndex + 'px';
            }
            return -listItemRef.current.offsetWidth * counterIndex + 'px';
        }
    };

    useEffect( () => {
        listRef.current.style.marginLeft = getMargin();
        onSlide && onSlide( counterIndex );

    }, [ counterIndex ] );
   
    return (
        <div className= { classNames }>

            {
                0 !== counterIndex &&
                <div className= 'ui-slider-carausel--left-arrow' onClick = { leftArrowCallback } >
                    <Icon id= { 'rightDirectionArrow' } fill = { '#003e7b' }/>
                </div>
            }

            <div className='ui-slider-carausel__content'>
                { React.Children.map( props.children, child =>
                    React.cloneElement( child, { listRef, listItemRef, marginLeft: getMargin() } ) )
                }
            </div>
            
            {
                ( listSize > overflowCount ) && counterIndex !== ( listSize - overflowCount ) &&
                <div className= 'ui-slider-carausel--right-arrow' onClick = { rightArrowCallback } >
                    <Icon id= { 'rightDirectionArrow' } fill = { '#003e7b' }/>
                </div>
            }

        </div>
    );
};

// set display name
sliderCarausel.displayName = 'sliderCarausel';

// set default props
sliderCarausel.defaultProps = {};

// prop types
sliderCarausel.propTypes = {};
